import { components } from 'react-select'

import type { ReactElement } from 'react'
import type { ControlProps } from 'react-select'

import { ABTestVariationBadge } from '../Badges'

const CustomVariationControl = ({ children, ...props }: ControlProps): ReactElement => {
  const { variationType } = props.selectProps

  return (
    <components.Control {...props}>
      <div style={{ paddingLeft: '1rem' }}>{variationType ? <ABTestVariationBadge value={variationType} /> : null}</div>
      {children}
    </components.Control>
  )
}

export default CustomVariationControl
